var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerfuegbarkeitschnittstelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "83px",
    viewBox: "0 0 76 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944625 9.5,22.361625 9.5,23.516625 L9.5,51.384625 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384625 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944625 63.2245,20.367125 L39.09,6.433125 Z",
    id: "path-1-verfuegbarkeit"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.6%",
    y: "-9.5%",
    width: "143.2%",
    height: "138.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-verfuegbarkeitsschnittstelle"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3-verfuegbarkeit",
    points: "0 0 33.172 0 33.172 25.2385 0 25.2385"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-color-gold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1007.000000, -986.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verfuegbarkeit-schnittstelle",
    transform: "translate(500.500000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-verfuegbarkeit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-verfuegbarkeitsschnittstelle)",
    xlinkHref: "#path-1-verfuegbarkeit"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F2F3F4",
    fillRule: "evenodd",
    xlinkHref: "#path-1-verfuegbarkeit"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke-color",
    d: "M39.09,6.433125 C38.0895,5.855625 36.4535,5.855625 35.453,6.433125 L11.3185,20.367125 C10.3185,20.944125 9.5,22.361625 9.5,23.516625 L9.5,51.384125 C9.5,52.539125 10.3185,53.956625 11.3185,54.534125 L35.453,68.468125 C36.4535,69.045625 38.0895,69.045625 39.09,68.468125 L63.224,54.534125 C64.2245,53.956625 65.0425,52.539125 65.0425,51.384125 L65.0425,23.516625 C65.0425,22.361625 64.2245,20.944125 63.2245,20.367125 L39.09,6.433125 Z",
    stroke: "#666666",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,6 C36.8886346,6.01803249 36.2852285,6.15628155 35.8201132,6.42676886 L11.8092236,20.3859175 C10.8138273,20.9644598 10,22.3840172 10,23.5411018 L10,51.4588982 C10,52.6159828 10.8138273,54.0360411 11.8092236,54.6145834 L35.8201132,68.5732311 C36.2852285,68.8437184 36.8886346,68.9824684 37.5,69 L37.5,6 Z",
    id: "overlay",
    fill: "#666666",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-verfuegbarkeit",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.500000, 10.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M12.70455,15.7048 L9.65705,15.7048 C9.10455,15.7048 8.65705,16.1528 8.65705,16.7048 C8.65705,17.2568 9.10455,17.7048 9.65705,17.7048 L12.70455,17.7048 C13.25655,17.7048 13.70455,17.2568 13.70455,16.7048 C13.70455,16.1528 13.25655,15.7048 12.70455,15.7048",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M27.4587,14.44555 L24.5127,17.62705 L22.4012,16.21055 C21.9427,15.90255 21.3212,16.02605 21.0132,16.48405 C20.7057,16.94305 20.8282,17.56405 21.2867,17.87205 L24.1087,19.76455 C24.2787,19.87805 24.4727,19.93405 24.6652,19.93405 C24.9357,19.93405 25.2042,19.82455 25.3997,19.61305 L28.9267,15.80405 C29.3017,15.39855 29.2772,14.76655 28.8717,14.39105 C28.4667,14.01555 27.8342,14.03955 27.4587,14.44555",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4-verfuegbarkeit",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3-verfuegbarkeit"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    d: "M24.91865,23.2385 C21.47065,23.2385 18.66565,20.4335 18.66565,16.9855 C18.66565,13.5375 21.47065,10.7325 24.91865,10.7325 C28.36665,10.7325 31.17215,13.5375 31.17215,16.9855 C31.17215,20.4335 28.36665,23.2385 24.91865,23.2385 L24.91865,23.2385 Z M7.17115,19.7285 L7.16315,9.353 L15.04315,9.3335 C15.37065,9.3325 15.67665,9.172 15.86315,8.903 L18.91465,4.4955 L18.91465,11.3405 C17.52465,12.818 16.66565,14.8015 16.66565,16.9855 C16.66565,17.9485 16.84015,18.869 17.14415,19.7285 L7.17115,19.7285 Z M6.62615,2 L18.20965,2 L14.51565,7.3345 L2.91215,7.3635 L6.62615,2 Z M30.12365,7.4105 L25.53665,7.3415 L21.85665,2 L26.39615,2 L30.12365,7.4105 Z M20.91465,4.1575 L24.09565,8.774 C22.95015,8.888 21.87465,9.2395 20.91465,9.7745 L20.91465,4.1575 Z M28.12415,9.3805 L32.03215,9.4395 L32.04715,9.4395 C32.41565,9.4395 32.75465,9.237 32.92915,8.911 C33.10515,8.5815 33.08265,8.18 32.87015,7.872 L27.90015,0.6585 C27.85865,0.598 27.81065,0.5445 27.75915,0.496 C27.58565,0.2005 27.26765,0 26.90015,0 L6.17165,0 C5.87865,0 5.61765,0.1285 5.43465,0.3295 C5.33565,0.3965 5.24565,0.481 5.17315,0.5855 L0.17815,7.7995 C-0.03435,8.1055 -0.05835,8.504 0.11465,8.8335 C0.28765,9.163 0.62815,9.3685 1.00015,9.3685 L1.00215,9.3685 L5.16315,9.358 L5.17165,20.7295 C5.17215,21.2815 5.61965,21.7285 6.17165,21.7285 L18.17565,21.7285 C19.67115,23.848 22.13365,25.2385 24.91865,25.2385 C29.46965,25.2385 33.17215,21.5365 33.17215,16.9855 C33.17215,13.571 31.08765,10.6345 28.12415,9.3805 L28.12415,9.3805 Z",
    fill: "#676767",
    mask: "url(#mask-4-verfuegbarkeit)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerfuegbarkeitschnittstelle);
export default __webpack_public_path__ + "static/media/verfuegbarkeitschnittstelle.913aec62865ff3a32e9febd4d585909b.svg";
export { ForwardRef as ReactComponent };